module.exports = __webpack_public_path__ + "img/shan.c85a69eb.png";